import { SHIFTS } from "@/constants/shifts";

/**
 * Radnici koji su naručili jedan obrok, po smenama (iz odgovora liste narudžbi firmi: { meals: [{ id, users:
 * { "1-smena": [{ id, name, lastname, quantity, external_code?, email? }] } }] }).
 * @returns {Array<{ id, name, initials, meta, shifts: [{ id, quantity }] }>} po imenu
 */
export const groupReservedWorkers = (data, meal, toLatin) => {
  const found = ((data && data.meals) || []).find((item) => meal && item.id === meal.id);
  if (!found || !found.users) {
    return [];
  }
  const byId = new Map();
  SHIFTS.forEach((shift) => {
    (found.users[`${shift.id}-smena`] || []).forEach((user) => {
      const worker = byId.get(user.id) || {
        id: user.id,
        name: [toLatin(user.name), toLatin(user.lastname)].filter(Boolean).join(" "),
        initials: [user.name, user.lastname]
          .filter(Boolean)
          .map((part) => String(part).charAt(0))
          .join(""),
        meta: [`ID ${user.id}`, user.external_code, user.email].filter(Boolean).join(" · "),
        shifts: [],
      };
      const entry = worker.shifts.find((item) => item.id === shift.id);
      if (entry) {
        entry.quantity += user.quantity || 1;
      } else {
        worker.shifts.push({ id: shift.id, quantity: user.quantity || 1 });
      }
      byId.set(user.id, worker);
    });
  });
  return [...byId.values()].sort((a, b) => a.name.localeCompare(b.name));
};
